import React from "react";

/**
 * Pulse waveform — a thin EKG/heartbeat line that pulses at ~60 BPM.
 * Used as the hero anchor for "Pulse AI" branding: reinforces the "living,
 * listening" feeling and ties visually to the product name *Pulse*.
 */
export default function PulseWaveform({ width = 96, className = "" }) {
  // 200×40 viewBox: long horizontal baseline with a centered heartbeat spike.
  // Two paths layered: a dim static one (the "track") + a bright animated one
  // that traces a glowing pulse along the same path (~60 BPM).
  const d =
    "M0,20 L60,20 L70,20 L74,8 L80,32 L86,6 L92,34 L96,20 L106,20 L200,20";

  return (
    <svg
      width={width}
      height={width * 0.2}
      viewBox="0 0 200 40"
      fill="none"
      className={`overflow-visible pulse-glow ${className}`}
      aria-hidden="true"
      data-testid="pulse-waveform"
    >
      {/* Static dim baseline */}
      <path
        d={d}
        stroke="#00E5FF"
        strokeOpacity="0.18"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Animated bright pulse tracing the path */}
      <path
        d={d}
        stroke="#00E5FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="40 220"
        className="pulse-trace"
      />
    </svg>
  );
}
